export default __webpack_public_path__ + "static/media/179.4276bf75.jpg";